module.exports = ['$resource', $resource => $resource('/api/v2/patient/session')];



// WEBPACK FOOTER //
// ./main/factories/session-resource.js